import { styled } from '@linaria/react';
import { Text } from '@daedalus/atlas/Text';
const _exp = /*#__PURE__*/() => Text;
export const Title = /*#__PURE__*/styled(_exp())({
  name: "Title",
  class: "t2teyos",
  propsAsIs: true
});

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");